"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningStatuses = void 0;
var SigningStatuses;
(function (SigningStatuses) {
    SigningStatuses["SIGNED"] = "SIGNED";
    SigningStatuses["TO_DECIDE"] = "TO_DECIDE";
    SigningStatuses["ENQUEUED"] = "ENQUEUED";
    SigningStatuses["HANDED_OVER"] = "HANDED_OVER";
    SigningStatuses["CANCELED"] = "CANCELED";
    SigningStatuses["REJECTED"] = "REJECTED";
    SigningStatuses["NOT_RECOGNIZED"] = "NOT_RECOGNIZED";
    SigningStatuses["VIEWER"] = "VIEWER";
    SigningStatuses["APPROVE_TO_DECIDE"] = "APPROVE_TO_DECIDE";
    SigningStatuses["APPROVE_CONSENTED"] = "APPROVE_CONSENTED";
    SigningStatuses["APPROVE_ENQUEUED"] = "APPROVE_ENQUEUED";
    SigningStatuses["APPROVE_REJECTED"] = "APPROVE_REJECTED";
    SigningStatuses["REVIEW_TO_DECIDE"] = "REVIEW_TO_DECIDE";
    SigningStatuses["REVIEW_POSITIVE"] = "REVIEW_POSITIVE";
    SigningStatuses["REVIEW_NEGATIVE"] = "REVIEW_NEGATIVE";
    SigningStatuses["ADVANCED_TO_DECIDE"] = "ADVANCED_TO_DECIDE";
    SigningStatuses["ADVANCED_SIGNED"] = "ADVANCED_SIGNED";
    SigningStatuses["ADVANCED_CANCELED"] = "ADVANCED_CANCELED";
})(SigningStatuses = exports.SigningStatuses || (exports.SigningStatuses = {}));
